export const LOGIN_REQUEST = `בשביל לחשב את שכר הדירה שלך יש קודם להכנס\n למערכת, קליק ואתם בפנים - זה בחינם!`;
export const LOGIN_REQUEST_DATA_VIEW_OPEN = `על מנת לצפות בכל הנתונים יש קודם לבצע התחברות`;
export const IT_IS_FREE = `זה בחינם!`;
export const LOGIN_BUTTON_TEXT = `כניסה למערכת`;
